<template>
  <section class="dashboard-card">
    <header class="dashboard-card-header">
      <div class="flex items-center">
        <VSvgIcon name="products" />
        <h2 class="dashboard-card-header-heading">{{ $t('dashboard.products.heading') }}</h2>
      </div>
      <router-link class="dashboard-card-header-link" to="/products">
        {{ $t('dashboard.products.action') }}
      </router-link>
    </header>
    <div class="text-center">
      <ul class="flex py-6 overflow-x-auto">
        <li
          v-for="(prod, index) in prods"
          :key="index"
          class="flex-shrink-0 w-4/6 px-3 sm:w-1/4"
          :class="[prods.length <= 4 && index < 3 && 'sm:border-r']"
        >
          <router-link
            v-slot="{ href, navigate }"
            :to="{ name: 'product', params: { id: prod.id || 0 } }"
            class="h-full"
          >
            <a :href="href" @click.stop="navigate" class="h-full">
              <div class="py-2 text-sm font-semibold">
                {{ stripOutVersion(prod.display_name) }}
              </div>
              <img
                class="object-contain object-center w-full h-40 py-1"
                :src="prod.thumbnail"
                alt="product"
              />
              <div>
                <router-link
                  :to="{
                    name: 'training-lessons',
                    params: { id: prod.id || 0 },
                  }"
                  class="py-2 text-xs font-bold text-blue-500 uppercase"
                  v-if="hasPretraining(prod)"
                >
                  {{ $t('dashboard.products.link') }} →
                </router-link>
                <router-link
                  :to="{
                    name: 'product',
                    params: { id: prod.id },
                  }"
                  v-if="isChromaProduct(prod)"
                  class="py-2 text-xs font-bold text-blue-500 uppercase"
                >
                  {{ $t('product.chroma_link') }} →
                </router-link>
              </div>
            </a>
          </router-link>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import VSvgIcon from '@/components/base/VSvgIcon';
import {
  isBlacklisted,
  removeDuplicates,
  removeDuplicateChroma,
  stripOutChromaVersion,
  isChroma,
} from '@/utils';

export default {
  name: 'DashboardProducts',
  components: { VSvgIcon },
  props: { products: Array },
  computed: {
    prods() {
      return removeDuplicateChroma(removeDuplicates(this.products, 'id').slice(0, 4));
    },
  },
  methods: {
    hasPretraining(prod) {
      return prod.has_videos && !isBlacklisted(prod.display_name) && prod.allows_pretraining;
    },
    stripOutVersion(name) {
      return stripOutChromaVersion(name);
    },
    isChromaProduct(product) {
      return isChroma(product.display_name);
    },
  },
};
</script>
